import style from './Menu.module.css'
import React from 'react'
import icons from '../../../../img/icons/icons'

interface IItemMenu {
    click: () => void
    nome: string
}

export const ItemMenu: React.FC <IItemMenu> = (props) =>{     
    function click (){
        props.click()
    }
    return (       
        <button type="button" className={style.ItemMenu} onClick={click}>
            {props.nome}
        </button>            
    )
}
// aqui estamos exportando nosso componente